import { render, staticRenderFns } from "./UnverifiedAlert.vue?vue&type=template&id=70d13d24&scoped=true"
import script from "./UnverifiedAlert.vue?vue&type=script&lang=js"
export * from "./UnverifiedAlert.vue?vue&type=script&lang=js"
import style0 from "./UnverifiedAlert.vue?vue&type=style&index=0&id=70d13d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d13d24",
  null
  
)

export default component.exports